// extracted by mini-css-extract-plugin
module.exports = {"channelRoot":"Channel_channelRoot__QG36Q"};